import Icon from '../components/Icon.vue'

Icon.register({
  'window-close': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-416c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h416zM380.4 322.5l-67.1-66.5 67.1-66.5c4.8-4.8 4.8-12.6 0-17.4l-40.5-40.5c-4.8-4.8-12.6-4.8-17.4 0l-66.5 67.1-66.5-67.1c-4.8-4.8-12.6-4.8-17.4 0l-40.5 40.5c-4.8 4.8-4.8 12.6 0 17.4l67.1 66.5-67.1 66.5c-4.8 4.8-4.8 12.6 0 17.4l40.5 40.5c4.8 4.8 12.6 4.8 17.4 0l66.5-67.1 66.5 67.1c4.8 4.8 12.6 4.8 17.4 0l40.5-40.5c4.8-4.8 4.8-12.6 0-17.4z'
      }
    ]
  }
})
